import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_SESSION_SECRET || "default-unsafe-key";

// Encrypt and store in localStorage
export function setSecureLocalItem(key, value) {
  try {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
    sessionStorage.setItem(key, encrypted);
    return true;
  } catch (error) {
    console.error("Error saving to sessionStorage:", error);
    return false;
  }
}

// Decrypt and retrieve from sessionStorage
export function getSecureLocalItem(key) {
  try {
    const encrypted = sessionStorage.getItem(key);
    if (!encrypted) return null;
    
    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch (error) {
    console.error("Error reading from sessionStorage:", error);
    return null;
  }
}

// Remove from sessionStorage
export function removeSecureLocalItem(key) {
  sessionStorage.removeItem(key);
}













//HOW TO USE THIS HERE 

// import { setSecureSessionItem, getSecureSessionItem, removeSecureSessionItem } from '../utils/secureSessionStorage';

// Save
// setSecureSessionItem('userSettings', { theme: 'dark' });

// Retrieve
// const settings = getSecureSessionItem('userSettings');

// Remove
// removeSecureSessionItem('userSettings');